import { render, staticRenderFns } from "./SliceNewsletterSignUpRow.vue?vue&type=template&id=79e632b2&lang=pug&"
import script from "./SliceNewsletterSignUpRow.vue?vue&type=script&lang=js&"
export * from "./SliceNewsletterSignUpRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports